import React, { useState } from "react";
import { Card, Form, Button, Spinner, Alert, Table } from "react-bootstrap";
import { getCekPembayaran } from "../../services/api";
import "./Dashboard.css";

const CekStatusPembayaran = () => {
  const [noDaftar, setNoDaftar] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    try {
      return new Date(dateStr).toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    } catch {
      return dateStr;
    }
  };

  const formatFieldName = (fieldName) => {
    return fieldName
      .replace(/_/g, " ")
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    setError(null);
    setResult(null);
    if (!noDaftar.trim()) {
      return setError("Masukkan Nomor Daftar terlebih dahulu.");
    }

    try {
      setLoading(true);
      const resp = await getCekPembayaran(noDaftar);
      const data = resp.data;

      if (!data || data.status !== "success") {
        setError("Data tidak ditemukan atau terjadi kesalahan pada API.");
        return;
      }

      if (!data.data || !Array.isArray(data.data) || data.data.length === 0) {
        setError("Tidak ada data pembayaran untuk nomor daftar ini.");
        return;
      }

      setResult(data);
    } catch (err) {
      console.error(err);
      setError(
        err.response?.data?.message ||
          err.response?.data?.error ||
          "Gagal memuat data pembayaran. Coba lagi.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div
        className="page-header-banner"
        style={{
          background:
            "linear-gradient(135deg, var(--primary-color) 0%, var(--primary-hover) 50%, var(--primary-dark) 100%)",
        }}
      >
        <div className="page-header-content">
          <div className="page-header-left">
            <div className="page-header-icon">
              <i className="fas fa-search-dollar"></i>
            </div>
            <div>
              <h1 className="page-header-title">Cek Status Pembayaran</h1>
              <p className="page-header-subtitle">
                Cek status pembayaran pengajuan sertifikat halal
              </p>
            </div>
          </div>
        </div>
      </div>

      <Card className="mt-4">
        <Card.Body>
          {error && (
            <Alert variant="danger" onClose={() => setError(null)} dismissible>
              {error}
            </Alert>
          )}

          <Form onSubmit={handleSearch} className="mb-3">
            <Form.Group className="d-flex gap-2">
              <Form.Control
                type="text"
                placeholder="Masukkan No. Daftar (contoh: SH2025-1-795914)"
                value={noDaftar}
                onChange={(e) => setNoDaftar(e.target.value)}
              />
              <Button
                type="submit"
                disabled={loading}
                variant="primary"
                style={{ minWidth: 100 }}
              >
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-1" />
                    Cari...
                  </>
                ) : (
                  <>
                    <i className="fas fa-search me-1"></i>
                    Cari
                  </>
                )}
              </Button>
            </Form.Group>
          </Form>

          {result && result.data && result.data.length > 0 && (
            <div className="mt-4">
              <div
                className="mb-3 p-3"
                style={{
                  background:
                    "linear-gradient(135deg, var(--primary-color) 0%, var(--primary-hover) 50%, var(--primary-dark) 100%)",
                  color: "#fff",
                  borderRadius: "0.375rem",
                }}
              >
                <div className="d-flex align-items-center gap-3">
                  <i className="fas fa-receipt fa-2x"></i>
                  <div>
                    <h5 className="mb-0 fw-bold">Status Pembayaran</h5>
                    <small style={{ opacity: 0.85 }}>
                      No. Daftar: {result.data[0].no_daftar || noDaftar}
                      {result.data[0].status_payment &&
                        ` • Status: ${result.data[0].status_payment}`}
                    </small>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <Table bordered hover className="mb-0">
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: "30%" }}>Field</th>
                      <th>Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(result.data[0])
                      .filter(
                        ([key, value]) => value !== null && value !== undefined,
                      )
                      .map(([key, value]) => {
                        let displayValue = value;

                        // Format date fields
                        if (
                          typeof value === "string" &&
                          /T\d{2}:\d{2}:\d{2}/.test(value)
                        ) {
                          displayValue = formatDate(value);
                        } else if (value === "") {
                          displayValue = "-";
                        } else if (typeof value === "object") {
                          displayValue = JSON.stringify(value);
                        }

                        return (
                          <tr key={key}>
                            <td
                              className="fw-semibold"
                              style={{ backgroundColor: "#f8f9fa" }}
                            >
                              {formatFieldName(key)}
                            </td>
                            <td>{displayValue}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>
              </div>

              <div
                className="mt-3 p-2 rounded"
                style={{
                  backgroundColor: "#e7f3ff",
                  border: "1px solid #b3d9ff",
                }}
              >
                <small className="text-muted">
                  <i className="fas fa-info-circle me-1"></i>
                  Data ditampilkan dari server SIHALAL. Total field:{" "}
                  {
                    Object.keys(result.data[0]).filter(
                      (k) => result.data[0][k] !== null,
                    ).length
                  }
                </small>
              </div>
            </div>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default CekStatusPembayaran;
